var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevisions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "revisions_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#revisions_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.757 17.583c-.366 0-.68-.132-.944-.395a1.289 1.289 0 01-.396-.944V5.756c0-.375.132-.692.396-.95a1.3 1.3 0 01.944-.39h1.82V2.879c0-.158.053-.29.16-.397a.535.535 0 01.395-.16c.157 0 .29.053.398.16.108.107.163.24.163.397v1.539h4.647V2.862c0-.153.052-.282.155-.386a.518.518 0 01.383-.155c.152 0 .28.051.387.155a.519.519 0 01.158.386v1.555h1.82c.366 0 .68.13.945.388.264.26.396.576.396.951v4.33a.526.526 0 01-.538.542.532.532 0 01-.387-.155.519.519 0 01-.159-.386v-.83h-11v6.987c0 .064.027.122.08.176.054.053.113.08.177.08h5.322a.526.526 0 01.541.538.532.532 0 01-.155.387.52.52 0 01-.386.158H4.757zM16 19.872c-.877 0-1.654-.26-2.332-.78a3.8 3.8 0 01-1.37-2 .483.483 0 01.018-.327c.043-.091.126-.137.249-.137.118 0 .223.04.316.12.094.08.157.181.191.302.242.657.621 1.167 1.138 1.532.517.364 1.114.546 1.79.546.864 0 1.602-.306 2.212-.917.611-.612.916-1.35.916-2.216 0-.865-.305-1.602-.916-2.21A3.02 3.02 0 0016 12.871c-.484 0-.946.116-1.387.347-.44.231-.832.534-1.175.91H14.5a.361.361 0 01.372.37.362.362 0 01-.372.373h-1.702a.648.648 0 01-.477-.193.648.648 0 01-.192-.477V12.5a.361.361 0 01.37-.372.362.362 0 01.373.372v1.159c.4-.479.87-.854 1.41-1.125A3.782 3.782 0 0116 12.128c1.072 0 1.985.378 2.74 1.134.755.756 1.132 1.67 1.132 2.743 0 1.072-.377 1.985-1.132 2.738-.755.752-1.668 1.129-2.74 1.129zM4.5 8.173h11V5.756a.245.245 0 00-.08-.176.245.245 0 00-.176-.08H4.757a.245.245 0 00-.177.08.245.245 0 00-.08.176v2.417z",
    fill: "#7A8D8F"
  }))));
}
export default SvgRevisions;